import { AU_PANEL_SX } from '@/theme/au-compat';
import { Box, BoxProps, Typography, TypographyProps } from '@mui/material';
import { FC } from 'react';

/**
 * El frame de card de un panel del modal. **Es el único**: ningún panel dibuja el suyo, ni con un
 * `bgcolor` ni con un borde propio, porque el escalón de superficie sólo se lee si lo pone el
 * contenedor una vez.
 *
 * `AU_PANEL_SX` primero y `props.sx` después: un panel ajusta su layout —`gridArea`, `display`,
 * `flexGrow`— pero no su piel.
 */
export const PanelPaper: FC<BoxProps> = (props) => {
  return (
    <Box
      {...props}
      sx={{
        ...AU_PANEL_SX,
        ...props.sx,
      }}
    />
  );
};

/**
 * `.oc-panel-title--left` — el rótulo de un panel: 14px/700, interlínea 1,25 y 8px de aire abajo,
 * alineado a la izquierda.
 *
 * Es el `--left` y no el `.oc-panel-title` pelado porque los **tres** paneles del monitor lo usan
 * así: el contenido de los tres arranca a la izquierda, y un título centrado sobre una lista
 * alineada a la izquierda no tiene con qué alinearse.
 *
 * No es el `h6` del theme (18px/600, además escalado por `responsiveFontSizes`): dentro de esta
 * ventana el `h6` es el título del diálogo, y un panel no compite con él.
 *
 * Va acá como componente y no como constante exportada porque `common.tsx` exporta **sólo**
 * componentes: un módulo que mezcla componentes con datos dispara
 * `react-refresh/only-export-components`, que con `--max-warnings 0` es un error de lint (G-039).
 */
export const PanelHeading: FC<TypographyProps> = ({ sx, ...props }) => {
  return (
    <Typography
      component="h4"
      {...props}
      sx={{
        fontSize: 14,
        fontWeight: 700,
        lineHeight: 1.25,
        mb: '8px',
        ...sx,
      }}
    />
  );
};
